import { apiSlice } from '@/features/api/apiSlice';

export type FlagDefinition = {
  key: string;
  default: boolean;
  description: string;
};

export type FeatureFlagsResponse = {
  catalog: FlagDefinition[];
  effective: Record<string, boolean>;
};

export const featureFlagsApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    getFeatureFlags: b.query<FeatureFlagsResponse, void>({
      query: () => '/feature-flags',
      providesTags: ['FeatureFlags'],
    }),
    setFeatureFlag: b.mutation<{ ok: true }, { key: string; enabled: boolean }>({
      query: ({ key, enabled }) => ({
        url: `/feature-flags/${key}`,
        method: 'PUT',
        body: { enabled },
      }),
      invalidatesTags: ['FeatureFlags', 'Me'],
    }),
    resetFeatureFlag: b.mutation<{ ok: true }, string>({
      query: (key) => ({ url: `/feature-flags/${key}`, method: 'DELETE' }),
      invalidatesTags: ['FeatureFlags', 'Me'],
    }),
  }),
});

export const {
  useGetFeatureFlagsQuery,
  useSetFeatureFlagMutation,
  useResetFeatureFlagMutation,
} = featureFlagsApi;
